/**
 * Created by m.igrachev on 6/19/2017.
 */
const documentedProperties = [
    {
        name: "value",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "The value of the Tooltip."
    },
    {
        name: "extraClasses",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Extra classes to put on the Tooltip."
    },
    {
        name: "maxWidth",
        type: "Number",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Number representing the max width of the Tooltip in pixels."
    },
    {
        name: "containerClass",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Optional container class for the Tooltip."
    },
    {
        name: "placeholderClass",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Optional placeholder class for the Tooltip."
    },
    {
        name: "preferredPosition",
        type: "['top', 'bottom']",
        defaultValue: "top",
        isRequired: "false",
        description: "The preferred position of the Tooltip."
    }
];

export default documentedProperties;
